var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('b-alert',{attrs:{"variant":"danger","show":"","dismissible":_vm.notdismissable === false}},[_c('i',{staticClass:"fas fa-exclamation-circle",staticStyle:{"color":"#a00"}}),_vm._v(" "+_vm._s(_vm.error)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }